import { observer } from 'mobx-react';
import React from 'react';
import { localeStore } from '~/mobx/localesStore';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import './style.scss';

export enum VatType {
  WITH_OR_WITHOUT_VAT = 1,
  INCLUDED_OR_EXCLUDED_VAT = 3,
}
interface IVatLabelProps {
  type: VatType;
  isVat: boolean;
}

const VatLabel: React.FC<IVatLabelProps> = observer(({ type, isVat }: IVatLabelProps): JSX.Element | null => {
  let text = null;
  let message = null;

  switch (type) {
    case VatType.WITH_OR_WITHOUT_VAT:
      text = isVat ? localeStore.t('txt_vat_tax') : localeStore.t('non_taxable');
      message = isVat ? 'hint_vat_with' : 'hint_vat_without';
      break;

    case VatType.INCLUDED_OR_EXCLUDED_VAT:
      text = isVat ? localeStore.t('vat_inc') : localeStore.t('vat_exc');
      message = isVat ? 'hint_vat_inc' : 'hint_vat_exc';
      break;
  }

  if (!text || !message) {
    return null;
  }

  return (
    <div className="vat-label">
      <p className="vat-hint">{text}</p>
      <TooltipIcon
        message={message}
        duration={TOOLTIP_DURATION.EXTRA_LARGE}
        position={TOOLTIP_POSITION.PORTAL}
        maxWidth={350}
        iconSize={14}
        iconClassName="mr-2"
      />
    </div>
  );
});

export default VatLabel;
